import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/en';

dayjs.extend(utc);
dayjs.extend(timezone);

// 格式化日期為 ISO 8601 格式
export const formatToISO = (time) => {
    return dayjs(time).tz('Asia/Taipei').format('YYYY-MM-DDTHH:mm:ssZ');
};

// 格式化日期為顯示格式 (DD MMM,YY)
export const formatToDisplay = (time) => {
    return dayjs(time).tz('Asia/Taipei').locale('en').format('DD MMM,YY');
};

export const formatToDisplayForArticle = (time) => {
    return dayjs(time).tz('Asia/Taipei').locale('en').format('DD MMM YY');
};
